import React from 'react';
import ProductPage from '../components/product-page';

export default function RetrofitsPage() {
  return (
    <ProductPage
      title="Retrofits"
      className="smart-power-commercial"
      images={[
        {
          src: 'retrofit-panel-with-desc.png',
          alt: 'Retrofit Interior, ships as a complete UL labeled assembly',
        },
        {
          youtubeId: '_y1lXK8TihE',
          src: 'retrofits-video-splash.png',
          alt: 'Old looking panelboard with youtube play button',
        },
      ]}
      sections={[
        {
          title: 'Description',
          id: 'description',
          content: (
            <ul>
              <li>Upgrade your existing panelboards with Smart Technology.</li>
              <li>
                The Retrofit interior ships as a complete assembly which
                provides time-efficient installation (4 to 8 man-hours).
              </li>
              <li>
                Our retrofit design maintains the integrity of the existing
                infrastructure. The conduit systems, conductors, and enclosures
                remain intact greatly reducing costs to upgrade.
              </li>
              <li>Front-end engineering design support is available.</li>
              <li>Retrofit LX Lighting Control Panels.</li>
            </ul>
          ),
        },
        {
          title: 'Downloads',
          id: 'downloads',
          content: (
            <ul style={{ listStyle: 'none' }}>
              <li>
                <a href="/downloads/application-note-metered-panelboard.pdf">
                  Application Note
                </a>
              </li>
              <li>
                <a href="/downloads/retrofit-panel-measurement-form.pdf">
                  Worksheet
                </a>
              </li>
            </ul>
          ),
        },
      ]}
    />
  );
}
